import React from 'react';
import svgAngleDoubleLeft from '../../svgs/angle-double-left.svg';
import svgAngleDoubleRight from '../../svgs/angle-double-right.svg';
import Icon from '../Icon';

export default React.createClass({
	propTypes: {
		count: React.PropTypes.number.isRequired,
		page: React.PropTypes.number.isRequired,
		totalCount: React.PropTypes.oneOfType([
			React.PropTypes.number,
			React.PropTypes.bool,
		]).isRequired,
		itemCount: React.PropTypes.number.isRequired,
	},
	getDefaultProps() {
		return {
			page: 1, 
		};
	},
	render() {
		let hasMore = null;

		// Display nothing if there is less than 1 page of items.
		if ((this.props.totalCount !== false && this.props.itemCount === this.props.totalCount) || (this.props.page === 1 && this.props.itemCount < this.props.count)) {
			return null;
		}

		if (this.props.totalCount !== false) {
			// If totalCount is false then it was probably too inefficient to get the count for this query.
			hasMore = this.props.count * this.props.page < this.props.totalCount;
		} else {
			// There are probably more results if the itemCount matches the request count.
			hasMore = this.props.itemCount > 0 && this.props.itemCount == this.props.count;
		}

		return (
			<div className='PaginateButtons'>
				<button className='PaginateButtons_btn' onClick={this.props.onPrev} disabled={this.props.page <= 1}>
					<Icon svg={svgAngleDoubleLeft}/> Prev
				</button>
				<button className='PaginateButtons_btn' onClick={this.props.onNext} disabled={!hasMore}>
					Next <Icon svg={svgAngleDoubleRight}/>
				</button>
			</div>
		);
	}
});